<template>
    <div :class="RowClass">
        <div style="display: flex; flex: 1;">
            <div class="checkbox-container">
                <div class="checkbox-container grow-medium" style="position:relative;">
                    <div class="checkbox" @click="toggleChecked($event)">
                        <div class="checkbox-fill" v-if="this.discountActive">
                            <p class="checkbox-text">✓</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-holder">
                <input type="text" v-model="localTitle" class="title text-field" :class="{'text-field-correct': titleCorrect,
                    'text-field-incorrect': (this.userTriedToCheck && !titleCorrect), 'hover-grow': !isReadOnly, 'text-field-active': !isReadOnly}" @input="UpdateDiscount()" :readonly="isReadOnly"/>
                <input type="text" v-model="localDescription" class="description text-field" :class="{'text-field-correct': descriptionCorrect,
                    'text-field-incorrect': (this.userTriedToCheck && !descriptionCorrect), 'hover-grow': !displayOnly, 'text-field-active': !displayOnly}" @input="UpdateDiscount()" :readonly="displayOnly"/>
            </div>
        </div>
        <div class="discount-details">
            <div v-if="!displayOnly">
                <PlusMinusButton :char="'+'" @plusMinusClick="UpdatePercentOff"/>
                <PlusMinusButton :char="'-'" @plusMinusClick="UpdatePercentOff"/>
            </div>
            <div class="bubble no-select" :class="{'bubble-incorrect': (this.userTriedToCheck === true && !bubbleCorrect)}">
                <template v-if="isOtherDiscount">
                    <span v-if="localDollarsOff != null" class="dollar-prefix no-select">$</span>{{ bubbleAmount }}<span v-if="localDollarsOff == null" class="percent-sign no-select">%</span>
                </template>
                <template v-else>{{ localPercentOff }}<span class="percent-sign no-select">%</span></template>
            </div>
            <div><h2> Off</h2></div>
            <div v-if="isOtherDiscount" class="trash-container">
                <i class="pi pi-trash delete hover-grow" title="Remove discount" @click="$emit('remove')"></i>
            </div>
            <div v-if="!isOtherDiscount" class="show-details-container" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                <button class="show-details-btn hover-grow" @click="togglePopup">{{isPopupPinned ? 'Hide Details' : 'Show Details'}}</button>
                <transition name="fade">
                    <div v-if="showDetailsPopup" class="benefits-popup">
                        <div class="popup-header">
                            <h3 class="popup-title">Discounted Benefits- {{ localTitle }}</h3>
                        </div>
                        <div class="popup-content">
                            <div class="benefit-row header-row">
                                <div class="benefit-name">Benefit</div>
                                <div class="benefit-ucr">UCR</div>
                                <div class="benefit-price">Discounted Price</div>
                            </div>
                            <div v-for="benefit in discountBenefits" :key="benefit.id" class="benefit-row">
                                <div class="benefit-name">{{ benefit.name }}</div>
                                <div class="benefit-ucr">${{ benefit.UCR || 0 }}</div>
                                <div class="benefit-price">${{ benefit.discountedPrice }}</div>
                            </div>
                            <div v-if="discountBenefits.length === 0" class="benefit-row">
                                <div class="benefit-name" style="grid-column: 1 / -1; text-align: center; color: var(--color-medium-gray);">
                                    No benefits specified
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import PlusMinusButton from './PlusMinusButton.vue'
import { mapActions } from 'vuex';

export default {
    name: 'DiscountRow',
    props: {
        id: {
            type: Number,
            default: null,
        },
        displayOnly: {
            type: Boolean,
            default: false,
        },
        otherDiscount: {
            type: Object,
            default: null,
        },
    },
    components: {
        PlusMinusButton,
    },
    data() {
        return {
            discountActive: true,
            localPercentOff: 2,
            localDollarsOff: null,
            localTitle: "",
            localDescription: "",
            userTriedToCheck: false,
            isPerio: null,
            isRestorative: null,
            showDetailsPopup: false,
            isPopupPinned: false,
        }
    },
    methods: {
        ...mapActions(['updateTreatmentDiscountByID', 'updateMonthlyDiscountByID']),
        UpdateDiscount() {
            if (this.isOtherDiscount) {
                let newDC = {
                    id: this.otherDiscount.id,
                    title: this.localTitle,
                    description: this.localDescription,
                    dollarsOff: this.localDollarsOff,
                    isActive: this.discountActive,
                    isSenior: this.otherDiscount.isSenior || false,
                    isMultiplePatient: this.otherDiscount.isMultiplePatient || false,
                };
                this.updateMonthlyDiscountByID(newDC);
                return;
            }
            let newDC = {
                id: this.id,
                title: this.localTitle,
                description: this.localDescription,
                percentOff: this.localPercentOff,
                isActive: this.discountActive,
                isPerio: this.isPerio,
                isRestorative: this.isRestorative
            };
            this.updateTreatmentDiscountByID(newDC);
        },
        UpdatePercentOff(value) {
            if (this.isOtherDiscount) {
                // Plan price discounts use dollars off
                const current = this.localDollarsOff != null ? this.localDollarsOff : 0;
                if (value === -1 && current <= 0) return;
                this.localDollarsOff = Math.max(0, current + value);
            } else {
                // Treatment discounts use percent off
                if ((value === -1 && this.localPercentOff === 0) || (value === 1 && this.localPercentOff === 100)) {
                    return;
                }
                this.localPercentOff += (value * 5);
            }
            this.UpdateDiscount();
        },
        toggleChecked() {
            this.userTriedToCheck = false;
            if(this.hasDefaultValues) {
                this.userTriedToCheck = true;
            }
            else {
                this.discountActive = !this.discountActive
            }
            this.UpdateDiscount()
        },
        togglePopup() {
            this.isPopupPinned = !this.isPopupPinned;
            this.showDetailsPopup = this.isPopupPinned;
        },
        handleMouseEnter() {
            if (!this.isPopupPinned) {
                this.showDetailsPopup = true;
            }
        },
        handleMouseLeave() {
            if (!this.isPopupPinned) {
                this.showDetailsPopup = false;
            }
        }
    },
    computed: {
        RowClass() {
            const rowId = this.isOtherDiscount ? this.otherDiscount.id : this.id;
            return {
                'full-row': true,
                'bg-gray-global': (rowId % 2) === 0
            }
        },
        isOtherDiscount() {
            return this.otherDiscount != null;
        },
        bubbleAmount() {
            if (this.isOtherDiscount && this.localDollarsOff != null) return this.localDollarsOff;
            return this.localPercentOff;
        },
        titleCorrect() {
            return this.localTitle !== "Type to Add Another"
        },
        descriptionCorrect() {
            return this.localDescription !== "Description"
        },
        bubbleCorrect() {
            if (this.isOtherDiscount) {
                return (this.localDollarsOff != null && this.localDollarsOff > 0) || (this.localPercentOff != null && this.localPercentOff > 0);
            }
            return this.localPercentOff > 0;
        },
        
        hasDefaultValues() {
            if(!this.titleCorrect || !this.descriptionCorrect || !this.bubbleCorrect) {
                return true;
            }
            return false;
        },
        displayWarning() {
            return (this.hasDefaultValues && this.userTriedToCheck)
        },
        isReadOnly() {
            if (this.isOtherDiscount) return true;
            if(this.id === 0 || this.id === 1) {
                return true;
            }
            return false;
        },
        discountBenefits() {
            // Define benefit ID arrays for each discount type
            const restorativeBenefitIds = [22, 23, 24]; // Crown, Filling, Root Canal
            const perioBenefitIds = [18, 19]; // Periodontal Scaling- Root Planing, Full Mouth Debridement
            
            // Determine which array to use based on isPerio and isRestorative
            let benefitIds = [];
            if (this.isRestorative === true) {
                benefitIds = restorativeBenefitIds;
            } else if (this.isPerio === true) {
                benefitIds = perioBenefitIds;
            }
            
            // If no discount type is specified, return empty array
            if (benefitIds.length === 0) {
                return [];
            }
            
            // Map benefit IDs to benefit objects with calculated discounted prices
            return benefitIds
                .map(benefitId => {
                    const benefit = this.$store.getters.getBenefitByID(benefitId);
                    if (!benefit) {
                        return null;
                    }
                    
                    // Calculate discounted price based on percentOff
                    const ucr = benefit.UCR || 0;
                    const discountedPrice = ucr > 0 
                        ? Math.ceil(ucr * (100 - this.localPercentOff) / 100)
                        : 0;
                    
                    return {
                        id: benefit.id,
                        name: benefit.name,
                        UCR: ucr,
                        discountedPrice: discountedPrice
                    };
                })
                .filter(benefit => benefit !== null);
        }
    },
    created() {
        if (this.otherDiscount) {
            this.localTitle = this.otherDiscount.title || '';
            this.localDescription = this.otherDiscount.description || '';
            this.discountActive = this.otherDiscount.isActive !== false;
            this.localDollarsOff = this.otherDiscount.dollarsOff != null ? this.otherDiscount.dollarsOff : null;
            this.localPercentOff = this.otherDiscount.percentOff != null ? this.otherDiscount.percentOff : 0;
            return;
        }
        let discount = this.$store.getters.getDiscountByID('T', this.id);
        this.localTitle = discount.title;
        this.localDescription = discount.description;
        this.discountActive = discount.isActive;
        this.localPercentOff = discount.percentOff;
        this.isPerio = discount.isPerio;
        this.isRestorative = discount.isRestorative;
    },
}
</script>

<style scoped>
.full-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    height: 70px;
    max-height: 80px;
    width: 95%;
}

.checkbox-container {
    display: flex;
    align-items: center;
    position: relative;
    margin-left: 3.5%;
}

.checkbox {
    position: relative;
    width: 25px;
    height: 25px;
    border: 2px solid var(--color-dark-blue);
    border-radius: 5px;
    cursor: pointer;
}

.checkbox-fill {
    position: absolute;
    left: 1px;
    top: 1px;
    width: 23px;
    height: 23px;
    background-color: var(--color-dark-blue);
    border-radius: 3px;
    color: white;
}

.checkbox-text {
    margin: 0;
    font-size: 1.5em;
    position: absolute;
    bottom: -3px;
    left: 2px;
}

.tooltip {
    position: absolute;
    background-color: var(--color-dark-blue);
    width: 130px;
    margin: 0;
    bottom: -21px;
    right: 50px;
}

.tooltip::after { /* This is the little arrowhead */
  content: "";
  position: absolute;
  right: -17px; /* Adjust based on the size of the arrow */
  top: 23px; /* Adjust to align the arrow with the middle of the box, if necessary */
  width: 0;
  height: 0;
  border-top: 10px solid transparent; /* Adjust size to change the arrow */
  border-bottom: 10px solid transparent; /* Adjust size to change the arrow */
  border-left: 10px solid var(--color-dark-blue); /* Border color should match the box's background */
  border-right: 10px solid transparent; /* This creates the arrow effect */
}

.tooltip p {
    margin: 0;
    padding: 0.4em;
    color: white;
}

.text-holder {
    flex: 2;
    text-align: left;
    margin-left: 2em;
}

.text-field {
    border: 2px solid transparent;
    background-color: transparent;
    width: 100%;
    max-width: 100%;
    padding: 2px;
}

.text-field-incorrect {
    border: 2px solid rgba(255, 0, 0, 0.3) !important;
    border-radius: 10px;
}

.text-field-active {
    cursor: pointer;
}

.text-field[readonly] {
    outline: none;
}

.text-field-active:hover:not([readonly]), .text-field-active:focus:not([readonly]) {
    border: 2px solid var(--color-light-blue);
    background-color: #fff;
    box-shadow: 3px 3px 5px var(--color-bright-blue-shadow);
    border-radius: 10px;
    outline: none;
}

.title {
    font-size: 24px;
    font-weight: 900;
}

.description {
    font-size: 16px;
    font-weight: 500;
}

.discount-details {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: transparent;
}

.bubble {
    background-color: white;
    color: var(--color-bright-blue);
    border: 2px solid var(--color-light-blue);
    border-radius: 10px;
    margin-left: 0.35em;
    margin-right: 0.35em;
    padding-right: 0.15em;
    padding-left: 0.15em;
    font-size: 2em;
    font-weight: 900;
    min-width: 55px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bubble-incorrect {
    border: 2px solid rgba(255,0,0,0.3);
}

.percent-sign {
    margin-top: 0.3em;
    margin-right: 0.1em;
    font-size: 0.65em;
}

.dollar-prefix {
    font-size: 0.75em;
    margin-right: 0.05em;
}

.trash-container {
    margin-left: auto;
    margin-right: 1.5em;
    font-size: 1.25em;
}

.show-details-container {
    position: relative;
    margin-left: 1em;
}

.show-details-btn {
    background-color: transparent;
    border: 2px solid var(--color-light-blue);
    border-radius: 8px;
    color: var(--color-dark-blue);
    font-size: 1em;
    font-weight: 600;
    padding: 0.5em 1em;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-left: 2em;
}

.show-details-btn:hover {
    /* background-color: var(--color-light-blue);
    color: white; */
    border-color: var(--color-bright-blue);
}

.benefits-popup {
    position: absolute;
    bottom: 100%;
    right: 0;
    margin-bottom: 10px;
    background-color: white;
    border: 2px solid var(--color-light-blue);
    border-radius: 12px;
    box-shadow: 0 4px 12px var(--color-light-blue-shadow);
    min-width: 400px;
    max-width: 500px;
    z-index: 1000;
    overflow: hidden;
}

.benefits-popup::after {
    content: "";
    position: absolute;
    bottom: -12px;
    right: 30px;
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 12px solid var(--color-light-blue);
}

.popup-header {
    background-color: var(--color-dark-blue);
    padding: 0.75em 1em;
    border-bottom: 2px solid var(--color-light-blue);
}

.popup-title {
    margin: 0;
    color: white;
    font-size: 1.1em;
    font-weight: 700;
}

.popup-content {
    padding: 0.5em 0;
    max-height: 400px;
    overflow-y: auto;
}

.benefit-row {
    display: grid;
    grid-template-columns: 2fr 1fr 1.2fr;
    gap: 1em;
    padding: 0.6em 1em;
    align-items: center;
    border-bottom: 1px solid var(--color-light-gray);
}

.benefit-row:last-child {
    border-bottom: none;
}

.benefit-row.header-row {
    background-color: var(--color-super-light-gray);
    font-weight: 700;
    color: var(--color-dark-blue);
    border-bottom: 2px solid var(--color-light-blue);
    padding: 0.75em 1em;
    font-size: 0.95em;
}

.benefit-name {
    text-align: left;
    color: var(--color-dark-gray);
    font-weight: 500;
}

.benefit-ucr {
    text-align: right;
    color: var(--color-medium-gray);
    font-weight: 500;
}

.benefit-price {
    text-align: right;
    color: var(--color-bright-blue);
    font-weight: 700;
    font-size: 1.05em;
}
</style>